import React, {Suspense} from 'react';
import CONST from "../../config/CONST";

const InstallmentPreviewWidget = React.lazy(() => import('./'+process.env.REACT_APP_SOURCE+'/InstallmentPreviewWidget'))

const InstallmentPreviewWidgetProxy = (props) => {

    if(process.env.REACT_APP_ENABLE_PREVIEW_WIDGETS !== "true") {
        return null;
    }

    return (
        <>
            <Suspense fallback={<div className={`${CONST.CSS_NAMESPACE}PreviewWidget_is-loading`}/>}>
                <InstallmentPreviewWidget {...props} />
            </Suspense>
        </>
    )
}

export default InstallmentPreviewWidgetProxy;